<template>
  <div >
    <el-dialog  title="新增司机" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"
    :visible="WHxuansijiFlag" width="900px" center  append-to-body>
      <div>
         <!-- 头部查询 -->
          <el-form :inline="true" :model="SJsearchFrom" ref="SJsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
            <div class=" inpBox">
              <el-form-item label="司机姓名:" prop="driverName">
                <el-input  placeholder="" v-model.trim="SJsearchFrom.driverName"></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="idNumber">
                <el-input  placeholder="" v-model.trim="SJsearchFrom.idNumber"></el-input>
              </el-form-item>
                  <el-form-item >
                <el-button type="primary" @click="SJsearchFn">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="resetForm()">重置</el-button>
              </el-form-item>
            </div>
          </el-form>
          <!-- 表格数据 -->
          <div>
            <!-- 表格 -->
            <div>
              <el-table
                :data="SJList"
                ref="table"
                bordersize="mini"
                @row-click="handleRowClick"
                class="table"
                height="380px"
                style="width: 100%"
                center
                border
              >
                <!-- <el-table-column type="selection" width="30" :reserve-selection="true"></el-table-column> -->
                <el-table-column  type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="SJZPfn(scope.row,2)" size="mini">指派</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="name" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
                <el-table-column prop="mobile"  label="联系电话"></el-table-column>
                  <el-table-column property="identityNo" label="身份证号">
                  <template scope="scope">
                    <p>
                      {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
                    </p>
                    <!-- <p v-else>{{scope.row.identityNo}}</p> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <!-- <div>
              <el-pagination background
                @size-change="SJhandleSizeChange"
                @current-change="SJhandleCurrentChange"
                :current-page="SJsearchFrom.pageNo"
                :page-sizes="[25,50,100]"
                :page-size="SJsearchFrom.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="SJtotal">
              </el-pagination>
            </div> -->
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
      </span>
      <el-dialog append-to-body title="选择车辆" :visible.sync="carMark"  :close-on-click-modal="false" width="900px" center>
        <!-- 内容 -->
        <div>
          <!-- 表格数据 -->
          <div class="tableQiye">
            <!-- 表格 -->
            <div>
              <el-table :data="carList" ref="table"  bordersize="mini"
                @row-click="handleRowClick"  class="table" height="380px" style="width: 100%"  center  border>
                <el-table-column type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="carOk(scope.row)" size="mini">选择车辆</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
                <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
                <el-table-column property="vehicleTenantName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
                <el-table-column prop="energyName"  width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
                <el-table-column prop="drivingLicense" width="170"  :show-overflow-tooltip="true" label="行驶证号"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="carMark=false">关闭</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { getDriverInfo, getVehicleInfo } from '@/api/newTMS'
export default {
  name: 'guanlianhetong',
  props: {
    WHxuansijiFlag: {
      type: Boolean,
      default: false
    },
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '市场司机'
        },
        {
          value: 2,
          label: '自家司机'
        }
      ],
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ]
      },
      addFrom: {},
      SJsearchFrom: {
      },
      SJList: [],
      SJtotal: 0,
      // 选择车辆
      carMark: false,
      carList: [],
      ZPFrom: {}
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
  },
  methods: {
    // 司机指派
    SJZPfn (row, n) {
      let that = this
      fuzhi()
      function fuzhi () {
        that.ZPFrom = row
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        getVehicleInfo({ driverId: row.id }).then(res1 => {
          let res = JSON.parse(res1)
          loading.close()
          if (res.length == 0) {
            that.$alert('该司机下暂无车辆', '系统提示')
          } else if (res.length == 1) {
            that.carOk(res[0])
          } else {
            that.carMark = true
            that.carList = res
          }
        })
      }
    },
    carOk (row) {
      for (var key in row) {
        this.ZPFrom[key] = row[key]
      }
      this.$emit('selectCar', this.ZPFrom)
      this.$emit('update:WHxuansijiFlag', false)
    },
    // 查选
    SJsearchFn () {
      this.SJgetList(this.SJsearchFrom)
    },
    // 获取列表
    SJgetList (searchFrom) {
      if (this.SJsearchFrom.driverName || this.SJsearchFrom.idNumber) {
        getDriverInfo(searchFrom).then(res => {
          let arr = JSON.parse(res)
          if (arr.length > 0) {
            this.SJList = JSON.parse(res)
          } else {
            this.$alert('没有在网货平台查到司机信息，请先让司机注册网货平台', '系统提示')
          }
        })
      }
    },
    // 每页条数
    SJhandleSizeChange (val) {
      this.SJsearchFrom.pageSize = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 当前页
    SJhandleCurrentChange (val) {
      this.SJsearchFrom.pageNo = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 重置
    resetForm (formName) {
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.ccarFrom = {}
    },
    closeDialog () {
      this.$emit('update:WHxuansijiFlag', false)
    }

  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>
/deep/.el-select{
  width: 180px;
}
</style>
